import { ICellRendererAngularComp } from "@ag-grid-community/angular";
import { ICellRendererParams } from "@ag-grid-community/core";
import { ChangeDetectionStrategy, Component, signal } from "@angular/core";
import { StrategyLinkComponent } from "@m19-board/shared/strategy-link/strategy-link.component";

type StrategyLinkGridParams = ICellRendererParams<unknown> & {
  strategyId: number;
  withCampaignType?: boolean;
};

@Component({
  selector: "app-strategy-link-grid",
  imports: [StrategyLinkComponent],
  template: `
    @if (strategyId(); as strategyId) {
      <app-strategy-link [strategyId]="strategyId" [withCampaignType]="withCampaignType()" />
    }
  `,
  host: { class: "flex w-full" },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrategyLinkGridComponent implements ICellRendererAngularComp {
  readonly strategyId = signal<number | undefined>(undefined);
  readonly withCampaignType = signal(false);

  agInit(params: StrategyLinkGridParams): void {
    this.applyParams(params);
  }

  refresh(_params: StrategyLinkGridParams): boolean {
    return false;
  }

  private applyParams(params: StrategyLinkGridParams): void {
    this.strategyId.set(params.strategyId);
    this.withCampaignType.set(params.withCampaignType ?? false);
  }
}
